import React from 'react';
import { Logo } from '@teambit/design.ui.brand.logo';

export const BitLogo = () => {
  return (
    <div style={{ width: '50%', margin: 'auto' }}>
      <Logo customSize={64} />
    </div>
  );
};
